import { addDays, eachDay, isAfter, isBefore, startOfDay, endOfDay } from 'date-fns';

const generateDates = function (params) {
  let { period, continuousUse, once, startDate, endDate } = params;

  const applyOnlyOnce = once === 1;

  let dates;

  if (applyOnlyOnce) {
    dates = [new Date(startDate)];
  } else {
    if (continuousUse === 1) {
      dates = eachDay(startDate, endDate);
    } else {
      const endDate = addDays(startDate, period);
      dates = eachDay(startDate, endDate);
    }
  }

  dates = [...dates].filter(
    date =>
      // Consider date that are not later than the endDate
      !isAfter(date, endOfDay(endDate)) &&
      // Consider date that are not before than the startDate
      !isBefore(date, startOfDay(startDate))
  );

  return dates;
};

export default generateDates;
